<template lang="html">
  <div class="global__alibabaguide">
    <!-- <router-link :to="{ name: 'PaymentAlibaba' }">
      <div id="alibabaPayment" class="global__alibaba d-flex align-items-center">
        <img class="" src="@/assets/image/image/alibaba gold suplier.png">
        <p>Alibaba Payment</p>
      </div>
    </router-link> -->
  </div>
</template>

<script>
export default {
  name: 'my-tour',
  data () {
    return {
      show: true
    }
  },
  mounted: function () {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/global/AlibabaTour.vue